import { Box, Typography, useTheme, List, ListItem } from '@mui/material';

import LogoSvg from '@/assets/assetfi/Logo';
import { useLocation, useNavigate } from 'react-router-dom';
import LayersFiledSvg from '@/assets/assetfi/LayersFilled';
import LayersSvg from '@/assets/assetfi/Layers';
import UserFiledSvg from '@/assets/assetfi/UserFilled';
import UserSvg from '@/assets/assetfi/User';

import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';

import packageJson from '../../../package.json';

export default function NavigateBar() {
  const version = packageJson.version;
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const NAVBAR_MENU = [
    {
      type: 'internal',
      id: 'layers',
      icon: location.pathname.startsWith('/pools') ? <LayersFiledSvg /> : <LayersSvg />,
      text: 'Pools',
      location: '/pools',
    },
    {
      type: 'internal',
      id: 'user',
      icon: location.pathname.startsWith('/portfolio') ? <UserFiledSvg /> : <UserSvg />,
      text: 'Portfolio',
      location: '/portfolio',
    },
    {
      type: 'external',
      id: 'tokens',
      icon: <MonetizationOnIcon />,
      text: 'Tokens',
      location: 'https://tokens.ecpay.io',
    },
  ];

  return (
    <Box
      sx={{
        width: '240px',
        height: '100%',
        borderRight: `0.5px solid ${theme.greyscale.lightgrey1}`,
        display: { xs: 'none', md: 'block' },
      }}
    >
      <Box
        sx={{
          boxShadow: '0px 0px 8px 0px #00000026',
          height: '64px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <LogoSvg />
        {/* <UserFilled width="150" height="150" /> */}
        {/* <UserFilled /> */}
      </Box>
      <List
        sx={{
          padding: '24px',
          gap: '10px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {NAVBAR_MENU.map((menu) => (
          <ListItem
            key={menu.id}
            onClick={() => {
              if (menu.type === 'internal') {
                navigate(menu.location);
              } else {
                window.open(menu.location, '_blank', 'noopener,noreferrer');
              }
            }}
            sx={{
              cursor: 'pointer',
              padding: '2px 0px 2px 20px',
              gap: '16px',
              borderRadius: '5px',
              background: location.pathname.startsWith(menu.location) ? '#357AFF1A' : '#ffffff',
            }}
          >
            {menu.icon}
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '18px',
                color: theme.greyscale.darkgrey2,
              }}
            >
              {menu.text}
            </Typography>
          </ListItem>
        ))}
      </List>
      <Box
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          margin: 2, // Optional: adds some margin from the bottom and right edge
        }}
      >
        <Typography variant="body1">version: {version}</Typography>
      </Box>
    </Box>
  );
}
